import React, { useState } from 'react';
import { FaUser, FaLock, FaEnvelope, FaPhone, FaWeixin, FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa';
import api from '../api';

const AddUserModal = ({ isOpen, onClose, onUserAdded, role }) => {
    const [formData, setFormData] = useState({
        username: '', password: '', name: '',
        email: '', phone: '', wechat: '', whatsapp: '', facebook: '', instagram: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        // CHECK: At least one contact field required
        const contacts = [formData.email, formData.phone, formData.wechat, formData.whatsapp, formData.facebook, formData.instagram];
        if (!contacts.some(c => c.trim() !== '')) {
            setError("At least one contact method (Email, Phone, WeChat, etc.) must be filled.");
            return;
        }

        setLoading(true);
        try {
            await api.post('/users', {
                username: formData.username,
                password: formData.password || 'welcome123',
                name: formData.name,
                role: role, 
                contactInfo: {
                    email: formData.email,
                    phone: formData.phone,
                    wechat: formData.wechat,
                    whatsapp: formData.whatsapp,
                    facebook: formData.facebook,
                    instagram: formData.instagram
                }
            });
            onUserAdded(); 
            onClose();     
        } catch (err) {
            setError(err.response?.data?.error || "Failed to create user");
        } finally { setLoading(false); }
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]">
                <div className="bg-blue-600 p-6 flex justify-between items-center text-white shrink-0">
                    <h3 className="text-xl font-bold flex items-center gap-2"><FaUser/> New {role}</h3>
                    <button onClick={onClose} className="text-white text-2xl">&times;</button>
                </div>
                <div className="p-6 overflow-y-auto">
                    {error && <div className="mb-4 bg-red-100 text-red-700 p-3 text-sm rounded">{error}</div>}
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div><label className="text-xs font-bold text-gray-500">Username</label><input name="username" required onChange={handleChange} className="w-full border p-2 rounded" placeholder="jdoe" /></div>
                            <div><label className="text-xs font-bold text-gray-500">Full Name</label><input name="name" required onChange={handleChange} className="w-full border p-2 rounded" placeholder="John Doe" /></div>
                        </div>
                        <div><label className="text-xs font-bold text-gray-500">Password</label><div className="relative"><FaLock className="absolute left-3 top-3 text-gray-400"/><input name="password" type="password" onChange={handleChange} className="w-full border p-2 pl-10 rounded" placeholder="Default: welcome123" /></div></div>
                        
                        <div className="space-y-3 pt-2 border-t mt-2">
                            <p className="text-xs font-bold text-gray-400 uppercase">Contact Details (Fill at least one)</p>
                            <div className="relative"><FaEnvelope className="absolute left-3 top-3 text-gray-400"/><input name="email" type="email" onChange={handleChange} className="w-full border p-2 pl-10 rounded text-sm" placeholder="Email Address" /></div>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="relative"><FaPhone className="absolute left-3 top-3 text-gray-400"/><input name="phone" onChange={handleChange} className="w-full border p-2 pl-10 rounded text-sm" placeholder="Phone" /></div>
                                <div className="relative"><FaWeixin className="absolute left-3 top-3 text-gray-400"/><input name="wechat" onChange={handleChange} className="w-full border p-2 pl-10 rounded text-sm" placeholder="WeChat ID" /></div>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                                <div className="relative"><FaWhatsapp className="absolute left-2 top-2.5 text-gray-400"/><input name="whatsapp" onChange={handleChange} className="w-full border p-2 pl-8 rounded text-xs" placeholder="WhatsApp" /></div>
                                <div className="relative"><FaFacebook className="absolute left-2 top-2.5 text-gray-400"/><input name="facebook" onChange={handleChange} className="w-full border p-2 pl-8 rounded text-xs" placeholder="Facebook" /></div>
                                <div className="relative"><FaInstagram className="absolute left-2 top-2.5 text-gray-400"/><input name="instagram" onChange={handleChange} className="w-full border p-2 pl-8 rounded text-xs" placeholder="Instagram" /></div>
                            </div>
                        </div>
                        <button type="submit" disabled={loading} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl shadow mt-4">{loading ? 'Creating...' : 'Create User'}</button>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default AddUserModal;